import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'op2mise-react-widgets';

export default function CampaignCopiedModal({ campaignName, hideCampaignCopiedModal }) {
  return (
    <Modal handleOnClose={hideCampaignCopiedModal}>
      <p>
        {campaignName}
        {' '}
        has been successfully created.
      </p>
    </Modal>
  );
}

CampaignCopiedModal.propTypes = {
  campaignName: PropTypes.string.isRequired,
  hideCampaignCopiedModal: PropTypes.func.isRequired,
};
